import { render, staticRenderFns } from "./ServiceRule.vue?vue&type=template&id=6cb76a74&scoped=true"
import script from "./ServiceRule.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ServiceRule.vue?vue&type=style&index=0&id=6cb76a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb76a74",
  null
  
)

export default component.exports